// DB-Portal – Verwaltung (Phase D): Lieferstand je Standort, Nutzerverwaltung.
import { z } from 'zod';
import { dbPortalFortschritt, dbPortalRolle } from './db-portal.js';
export const dbPortalLieferstandStandort = z.object({
    id: z.string().uuid(),
    externeId: z.string().nullable(),
    name: z.string(),
    ort: z.string().nullable(),
    gebietSlug: z.string().nullable(),
    gebietName: z.string().nullable(),
    prioritaet: z.number().int().nullable(),
    nutzer: z.array(z.object({ id: z.string().uuid(), name: z.string() })),
    fortschritt: dbPortalFortschritt,
    lieferungen: z.number().int(),
    offen: z.number().int(), // Lieferungen in Prüfung (offen oder Nachforderung beantwortet)
    nachforderung: z.number().int(),
    dokumente: z.number().int(),
    nichtAuswertbar: z.number().int(),
    letzteLieferung: z.string().nullable(), // ISO-Zeitpunkt
});
export const dbPortalLieferstand = z.object({
    standorte: z.array(dbPortalLieferstandStandort),
    summe: z.object({
        standorte: z.number().int(),
        vollstaendig: z.number().int(),
        ohneLieferung: z.number().int(),
        offen: z.number().int(),
        dokumente: z.number().int(),
    }),
});
export const dbPortalNutzerEintrag = z.object({
    id: z.string().uuid(),
    email: z.string(),
    anzeigename: z.string().nullable(),
    organisation: z.string().nullable(),
    rolle: dbPortalRolle,
    aktiv: z.boolean(),
    ndaVersion: z.string().nullable(),
    ndaAkzeptiertAm: z.string().nullable(),
    letzteAnmeldungAm: z.string().nullable(),
    erstelltAm: z.string(),
    standorte: z.number().int(),
});
export const dbPortalNutzerAendern = z
    .object({
    aktiv: z.boolean().optional(),
    anzeigename: z.string().trim().max(120).nullable().optional(),
    organisation: z.string().trim().max(120).nullable().optional(),
})
    .refine((a) => Object.keys(a).length > 0, { message: 'Keine Änderung angegeben' });
//# sourceMappingURL=db-portal-verwaltung.js.map